import React from "react";
import { Helmet } from "react-helmet";
import { FaFilePdf, FaShieldAlt, FaInfoCircle, FaCalendarAlt, FaMoneyBillWave } from "react-icons/fa";

function Insurance() {
  return (
    <>
      <Helmet>
        <title>VBU - Students and Faculty Insurance (PMSBY)</title>
      </Helmet>
      <div className="PageContainer">
        <div className="Campus">
          <div id="Heading">
            <h1>Students and Faculty Insurance</h1>
          </div>

          <div className="Desc">
            <div className="DescParagraph" style={{ width: '100%' }}>
              <div style={{ marginBottom: '40px' }}>
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#0f1a41', marginBottom: '20px' }}>
                  <FaShieldAlt /> Pradhan Mantri Suraksha Bima Yojana (PMSBY)
                </h2>
                <p>
                  The <strong>Pradhan Mantri Suraksha Bima Yojana (PMSBY)</strong> is an Accident Insurance Scheme offering accidental death and disability cover for death or disability on account of an accident. It is a one-year cover, renewable from year to year.
                </p>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '40px' }}>
                <div style={{ backgroundColor: '#f8f9fa', padding: '25px', borderRadius: '15px', borderLeft: '5px solid #0f1a41' }}>
                  <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.2rem', marginBottom: '15px' }}>
                    <FaInfoCircle color="#0f1a41" /> Scope of Coverage
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.6' }}>
                    All individual bank/Post office account holders in the age group of <strong>18 to 70 years</strong> are eligible. Enrolment is limited to one bank account only. Aadhaar is the primary KYC for the account.
                  </p>
                </div>

                <div style={{ backgroundColor: '#f8f9fa', padding: '25px', borderRadius: '15px', borderLeft: '5px solid #34a853' }}>
                  <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.2rem', marginBottom: '15px' }}>
                    <FaCalendarAlt color="#34a853" /> Enrolment Period
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.6' }}>
                    The cover is for a one-year period from <strong>1st June to 31st May</strong>. Premium is deducted via auto-debit by 31st May of every year.
                  </p>
                </div>

                <div style={{ backgroundColor: '#f8f9fa', padding: '25px', borderRadius: '15px', borderLeft: '5px solid #fbbc05' }}>
                  <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.2rem', marginBottom: '15px' }}>
                    <FaMoneyBillWave color="#fbbc05" /> Annual Premium
                  </h3>
                  <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.6' }}>
                    The premium is <strong>Rs. 20/- per annum</strong> per member. It is deducted from the account holder's bank/Post office account through 'auto-debit' in one instalment.
                  </p>
                </div>
              </div>

              <h3 style={{ marginBottom: '20px', color: '#202124' }}>Table of Benefits</h3>
              <div style={{ overflowX: 'auto', marginBottom: '40px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 0 20px rgba(0,0,0,0.05)' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#0f1a41', color: 'white', textAlign: 'left' }}>
                      <th style={{ padding: '15px 20px' }}>Sl. No.</th>
                      <th style={{ padding: '15px 20px' }}>Benefits</th>
                      <th style={{ padding: '15px 20px' }}>Sum Insured</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '15px 20px' }}>a</td>
                      <td style={{ padding: '15px 20px' }}>Death</td>
                      <td style={{ padding: '15px 20px' }}>Rs. 2 Lakh</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #eee', backgroundColor: '#fdfdfd' }}>
                      <td style={{ padding: '15px 20px' }}>b</td>
                      <td style={{ padding: '15px 20px' }}>Total and irrecoverable loss of both eyes or loss of use of both hands or feet or loss of sight of one eye and loss of use of hand or foot</td>
                      <td style={{ padding: '15px 20px' }}>Rs. 2 Lakh</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '15px 20px' }}>c</td>
                      <td style={{ padding: '15px 20px' }}>Total and irrecoverable loss of sight of one eye or loss of use of one hand or foot</td>
                      <td style={{ padding: '15px 20px' }}>Rs. 1 Lakh</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div style={{ backgroundColor: '#fff4f4', padding: '30px', borderRadius: '15px', border: '1px solid #ffebeb', marginBottom: '40px' }}>
                <h3 style={{ color: '#d93025', marginBottom: '15px' }}>Termination of Cover</h3>
                <ul style={{ paddingLeft: '20px', lineHeight: '1.8', color: '#3c4043' }}>
                  <li>On attaining age 70 years (age nearest birthday).</li>
                  <li>Closure of account with the Bank/Post office or insufficiency of balance.</li>
                  <li>Restricted to one bank/Post office account only if multiple exist.</li>
                  <li>Technical reasons like insufficient balance may lead to suspension of risk cover.</li>
                </ul>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '15px', justifyContent: 'center' }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  backgroundColor: 'white', 
                  padding: '15px 25px', 
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  border: '1px solid #e8eaed'
                }}>
                  <FaFilePdf size={28} color="#dc3545" style={{ marginRight: '15px' }} />
                  <div>
                    <h4 style={{ margin: 0, color: '#202124', fontSize: '1.1rem' }}>Download Rules & Detailed Scheme</h4>
                    <p style={{ margin: 0, color: '#5f6368', fontSize: '0.9rem' }}>Official PMSBY PDF Document</p>
                  </div>
                  <a 
                    href="/docs/insurance.pdf" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      marginLeft: '30px',
                      padding: '12px 25px',
                      backgroundColor: '#0f1a41',
                      color: 'white',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontWeight: '600',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 2px 4px rgba(15,26,65,0.2)'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = '#02215b';
                      e.target.style.boxShadow = '0 4px 8px rgba(15,26,65,0.3)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = '#0f1a41';
                      e.target.style.boxShadow = '0 2px 4px rgba(15,26,65,0.2)';
                    }}
                  >
                    View PDF
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Insurance;
